<template>
  <asc-header
    class="asc-report-title"
    :value="value"
    size="h1"
    uppercase
  ></asc-header>
</template>

<script>
import AscHeader from '@/components/atoms/AscHeader'

export default {
  name: 'AscReportTitle',

  components: {
    AscHeader,
  },

  props: {
    value: {
      type: String,
      required: true,
    },
  },
}
</script>

<style lang="scss">
.asc-report-title {
  & .asc-header--h1 {
    font-size: 16px;
  }
}
</style>
